import client from '../../client';

const QUARTERS = {
  getQuarter(quarterId) {
    return client.get(`/eugene/quarters/${quarterId}`)
  },

  getNearbyQuarters(lng, lat, quarterId, radius = 500) {
    return client.get('/eugene/quarters', { lng, lat, radius, quarter_id: quarterId })
  },

  getQuarterExperts(saleId, quarterId) {
    return client.get(`/eugene/sales/${saleId}/quarters/${quarterId}/experts`)
  },

  getQuarterGeojson(quarterId) {
    return client.get(`/quarters/${quarterId}/geojson`)
  },

  updateQuarterDescription(quarterId, description) {
    return client.put(`/eugene/quarters/${quarterId}`, { quarter: { description: description } });
  },

  generateQuarterDescription(quarterId) {
    return client.get(`/eugene/quarter_description_generator/${quarterId}`);
  },
}

export default QUARTERS;
